import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: `fedauth px-0 mx-0 theme--${_vm.UiTheme ? 'dark' : 'light'}`
  }, [_c(VDialog, {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.deleteDialog,
      callback: function ($$v) {
        _vm.deleteDialog = $$v;
      },
      expression: "deleteDialog"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    class: `headline ${_vm.color}--text`
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.questionDeleteItem')))]), _c(VCardText, {
    staticClass: "mt-2"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('accMgmt.tenant.federatedAuth.deleteConfirmation')) + "\n      ")]), _c(VDivider), _c(VCardActions, [_c(VSpacer), _c('core-button', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.deleteDialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.cancel')) + "\n        ")]), _c('core-button', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        _vm.deleteDialog = false;
        _vm.deleteClient(_vm.deleteClientIndex);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.tenant.federatedAuth.deleteButton')) + "\n        ")])], 1)], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "justify": "space-between"
    }
  }, [_c(VCol, {
    staticClass: "pt-1 pb-0 mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "7",
      "lg": "8"
    }
  }, [_c('h4', [_vm._v("\n        " + _vm._s(_vm.$i18n_t('accMgmt.tenant.federatedAuth.title')) + "\n      ")]), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.federatedAuth.subtitle')))])]), _c(VCol, {
    staticClass: "pt-1 pb-0 mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "5",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "display-box"
  }, [_c(VSelect, {
    staticClass: "client-select",
    attrs: {
      "item-text": "text",
      "item-value": "param",
      "items": _vm.clientTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "dense": _vm.dense,
      "return-object": "",
      "hide-details": "",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.clientType,
      callback: function ($$v) {
        _vm.clientType = $$v;
      },
      expression: "clientType"
    }
  }), _c('core-button', {
    staticClass: "float-right",
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.addClient(_vm.clientType.param);
      }
    }
  }, [_vm._v("\n          " + _vm._s(!_vm.isMobile ? _vm.$i18n_t('accMgmt.tenant.federatedAuth.newClient') : '') + "\n        ")])], 1)])], 1), _vm._l(_vm.clients, function (client, i) {
    return _c('span', {
      key: `fedauth_${i}`
    }, [_c('core-n20Card', {
      class: `px-0 py-0 theme--${_vm.UiTheme ? 'dark' : 'light'} dt-card-text-01`,
      attrs: {
        "border": `1px solid ${client.clientColor}`
      },
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [_c('span', [_c('core-button', {
            attrs: {
              "disabled": client.clientColor === 'none',
              "color": _vm.color,
              "prepend-icon": "fa-check"
            },
            on: {
              "click": function ($event) {
                return _vm.validateAndSave(i);
              }
            }
          }, [_vm._v("\n            " + _vm._s(!_vm.isMobile ? _vm.$i18n_t('accMgmt.tenant.federatedAuth.validate') : '') + "\n          ")])], 1), _c('core-button', {
            attrs: {
              "color": _vm.color,
              "prepend-icon": "fa-trash-alt"
            },
            on: {
              "click": function ($event) {
                _vm.deleteClientIndex = i;
                _vm.deleteDialog = true;
              }
            }
          })];
        },
        proxy: true
      }], null, true)
    }, [_c(VRow, {
      staticStyle: {
        "min-width": "0"
      },
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "py-1 my-0",
      attrs: {
        "cols": "8"
      }
    }, [_c('span', {
      class: `overline ${client.state === 'error' ? 'danger--text' : ''}`
    }, [_vm._v("\n            " + _vm._s(client.description) + "\n            "), client.id ? _c('span', [_vm._v("(ID: " + _vm._s(client.id) + ")")]) : _vm._e()]), _c('h4', {
      staticClass: "py-0 my-0"
    }, [client.state === 'error' ? [_c(VIcon, {
      staticClass: "mr-2",
      attrs: {
        "color": "danger",
        "size": "16"
      }
    }, [_vm._v("fal fa-exclamation-triangle")])] : _vm._e(), _c('span', {
      class: `text-bold ${client.state === 'error' ? 'danger--text' : ''}`
    }, [_vm._v(_vm._s(client.name))])], 2)])], 1), client.state === 'error' ? _c(VRow, {
      staticStyle: {
        "min-width": "0"
      },
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "danger--text"
    }, [_c('span', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.federatedAuth.errorNote')) + ":")]), _vm._v("\n            " + _vm._s(client.error) + "\n          ")])])], 1) : _vm._e(), _c(VRow, {
      staticStyle: {
        "min-width": "0"
      },
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c(VTextField, {
      attrs: {
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.tenant.federatedAuth.clientName'),
        "autocomplete": "off",
        "hide-details": "auto"
      },
      on: {
        "input": function ($event) {
          return _vm.setClientColor(i, 'changed');
        }
      },
      model: {
        value: client.name,
        callback: function ($$v) {
          _vm.$set(client, "name", $$v);
        },
        expression: "client.name"
      }
    })], 1), _c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c(VTextField, {
      attrs: {
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "color": _vm.color,
        "label": _vm.$i18n_t('Common.description'),
        "autocomplete": "off",
        "hide-details": "auto"
      },
      on: {
        "input": function ($event) {
          return _vm.setClientColor(i, 'changed');
        }
      },
      model: {
        value: client.description,
        callback: function ($$v) {
          _vm.$set(client, "description", $$v);
        },
        expression: "client.description"
      }
    })], 1), _c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c('div', {
      staticClass: "image-upload-wrapper",
      on: {
        "click": function ($event) {
          return _vm.$refs.attachmentInput[i].click();
        }
      }
    }, [_c('img', {
      staticClass: "image-upload-img",
      attrs: {
        "src": client.logo ? client.logo : 'img/niota-classic/placeholder.png'
      }
    }), _c('input', {
      ref: "attachmentInput",
      refInFor: true,
      staticStyle: {
        "visibility": "hidden",
        "width": "0",
        "height": "0"
      },
      attrs: {
        "type": "file",
        "name": "image",
        "accept": "image/png"
      },
      on: {
        "input": function ($event) {
          return _vm.changeLogo(i);
        }
      }
    })])]), _c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "12"
      }
    }, [client.allowUserCreation ? _c(VAlert, {
      staticClass: "mb-1",
      attrs: {
        "color": "transparent",
        "icon": "fal fa-comment-check"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.federatedAuth.newUserCreationEnabled')))])]) : _c(VAlert, {
      staticClass: "mb-1",
      attrs: {
        "color": "transparent",
        "icon": "fal fa-comment-exclamation"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.federatedAuth.newUserCreationDisabled')))])])], 1), _c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "12"
      }
    }, [_c(VExpansionPanels, {
      attrs: {
        "value": client.collapsedConfig
      }
    }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.federatedAuth.clientTemplate')))])]), _c(VExpansionPanelContent, [_c('codemirror', {
      ref: "codemirror",
      refInFor: true,
      staticClass: "elevation-3",
      attrs: {
        "options": _vm.cMOptions
      },
      on: {
        "input": function ($event) {
          return _vm.setClientColor(i, 'changed');
        }
      },
      model: {
        value: client.json,
        callback: function ($$v) {
          _vm.$set(client, "json", $$v);
        },
        expression: "client.json"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)], 1);
  }), !_vm.clients || _vm.clients.length === 0 ? _c('div', {
    staticClass: "empty-alert"
  }, [_c(VAlert, {
    staticClass: "mb-1",
    attrs: {
      "value": true,
      "color": "transparent",
      "icon": "fal fa-comment-exclamation"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('accMgmt.tenant.federatedAuth.nothingToDisplay')) + "\n    ")])], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };